import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Colors } from '../../../utils/resources/colors';
import { Fonts } from '../../../utils/resources/fonts';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export interface ToolbarCSSStyle extends UIComponentCSSStyle
{
    getToolbarContainerCSSStyle(): object;
    getIconCSSStyle(): object;
    getAllTitleDivCSSStyle(): object;
    getTitleCSSStyle(isSelected:boolean): object;
    getTitleDivCSSStyle(): object;
    getTitle2DivCSSStyle():object;
    geDoItYouselfCSSStyle(isSelected:boolean): object;
    getTunesDropDownSSStyle(): object;
    getSignUpCSSStyle(): object ;
    getButtonDivCSSStyle():object;

}

export class ToolbarCSSStyleImpl extends UIComponentCSSStyleImpl implements ToolbarCSSStyle
{
    getSignUpCSSStyle(): object 
    {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "30px",
            paddingBottom: "2px",
            fontWeight:"bold",
            letterSpacing: 0,
            cursor: "pointer",
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_2),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "80px"
        };
    }   
    getToolbarContainerCSSStyle(): object 
    {
        return {
            display: "flex",
            // height: "79px",
           
            height: "auto",
            justifyContents: "center",
            flexFlow: "row wrap",
            position: "sticky",
            marginTop:"44px",
            zIndex: 1000,
            backgroundColor: "#4D4D4D",
            opacity: 1,
            // borderTop: "1px solid " + this.getResources().getColor(Colors.color_3),
        };
    }

    getIconCSSStyle(): object 
    {
        return {
            height: "46px",
            marginTop: "17px",
            marginBottom: "17px",
            cursor: "pointer"
        };
    }

    getAllTitleDivCSSStyle(): object 
    {
        return {
            display: "inline",
            width: "350px",
            flex: 1
            // paddingLeft: "30px",
            // paddingRight: "30px"
        };
    }

    getTitleCSSStyle(isSelected:boolean): object {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "80px",
            fontWeight: "bold",//isSelected? 700 : 300,
            letterSpacing: 0,
            cursor: "pointer",
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: "16px",
            color:isSelected?this.getResources().getColor(Colors.color_5):this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "80px"
        };
    }

    geDoItYouselfCSSStyle(isSelected:boolean): object 
    {
        return {
            display: "inline-block",
            textAlign: "center",
            height: "30px",
            cursor: "pointer",
            fontWeight:  "bold",//isSelected? 700 : 300,
            width: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ?"102px":'102px',
            letterSpacing: 0,
            textShadow: "0 1px 1px 0 rgba(0,0,0,0.18)",
            fontSize: "16px",
            color: isSelected?this.getResources().getColor(Colors.color_5):this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "80px",
        };
    }

    getTitleDivCSSStyle(): object 
    {
        return {
            display: "inline",
            paddingLeft: "0px",
            paddingRight: "0px",
        };
    }

    getTitle2DivCSSStyle():object{
        return{
            display: "inline",
            paddingLeft: "0px",
            paddingRight: "0px",
        };
    }

    getTunesDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            flexFlow: "row nowrap",
            width: "100%",
            justifyContent:"center",
            height: "200px",
            marginTop: "29px",
            paddingLeft: "30px", 
            paddingRight: "30px", 
            position: "absolute",
            zIndex: 2,
            borderRadius:'0px 0px 8px 8px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5),
            right:'0px'
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            width:'117px',
            color:'#ffffff',
            marginTop: "9px",
            marginRight: "40px",
            marginLeft: "40px"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbar/toolbarcss.tsx